import React from "react";
import { FaAngellist, FaLinkedinIn } from "react-icons/fa";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";

export default function Icons() {
  return (
    <div className="icons">
      <a
        href="https://angel.co/u/nesrine-mrabet"
        target="_blank"
        rel="noreferrer"
      >
        <FaAngellist size="35" color="#cfcfaf" />
      </a>
      <a
        href="https://www.linkedin.com/in/nmrabet/"
        target="_blank"
        rel="noreferrer"
      >
        <FaLinkedinIn size="35" color="#89c7aa" />
      </a>
      <a href="https://github.com/nmrabet" target="_blank" rel="noreferrer">
        <AiFillGithub size="35" color="#f6ae9f" />
      </a>
      <a
        href="https://twitter.com/NesrineMrabet"
        target="_blank"
        rel="noreferrer"
      >
        <AiOutlineTwitter size="35" color="#ff6b58" />
      </a>
    </div>
  );
}
